import { useEffect } from 'react';

import type { ILesson } from '../../graphql/types';

/**
 * Custom hook to track resource views for single-lesson courses
 *
 * @param lesson - The lesson data
 * @param isSingleLessonCourse - Whether this is a single-lesson course
 * @param resourceType - The type of resource
 */
export const useTrackSingleLessonResourceView = (
  lesson: ILesson | null,
  isSingleLessonCourse: boolean,
  resourceType: string,
) => {
  useEffect(() => {
    // Single-lesson courses redirect straight to the lesson
    // we need to track a resource view when users land here
    // since we can't capture a view on the course overview
    if (lesson && isSingleLessonCourse && lesson?.course) {
      window.klaviyo?.track('Viewed Academy resource', {
        resourceType,
        resourceId: lesson.course.thirdPartyId,
        url: `${window.location.origin}${window.location.pathname}`,
      });
    }
  }, [lesson, isSingleLessonCourse, resourceType]);
}; 
